import { render, staticRenderFns } from "./SetCreateEdit.vue?vue&type=template&id=7152cfc9&scoped=true&"
import script from "./SetCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SetCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/sets/SetCreateEdit/SetCreateEditStyle.css?vue&type=style&index=0&id=7152cfc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152cfc9",
  null
  
)

export default component.exports